// Manual free-form tabletop gesture intent builders (C3). Returns a
// { domain:'manual', kind, ... } object the server's match:intent handler
// routes into manualService. The server derives identity/controller/position
// from its own MatchState and mints the copy's id deterministically from the
// idempotency key, so both seats render it from the diff
// (rebuildBoardFromMirror). Keep payload shapes in lockstep with
// valkenhall-server/src/match/manualService.js.

let _seq = 0;
// A client-generated idempotency key so a re-sent gesture (reconnect replay,
// double-send) is deduped on the SERVER spine. And, because the minted id is
// derived from it, at-most-once even past the dedupe.
function nextKey(kind, sourceId) {
  _seq += 1;
  return `man-${kind}-${sourceId}-${Date.now()}-${_seq}`;
}

// Spawn a fresh token copy of the on-table card `sourceId` next to the
// original (context-menu "Duplicate").
export function duplicateIntent(sourceId) {
  return {
    domain: 'manual',
    kind: 'duplicate',
    sourceId,
    idempotencyKey: nextKey('duplicate', sourceId),
  };
}

// Spawn a catalog token at a board cell (token drawer / Token Browser /
// infinite pile). The server mints the instance (deterministic from the
// idempotency key), owns it as real MatchState, and both seats render it
// from the diff. `seat` is the spawning seat and is verified server-side
// against the acting seat.
export function spawnTokenIntent({ cardId, seat, col, row, x, z }) {
  return {
    domain: 'manual',
    kind: 'spawnToken',
    cardId,
    seat,
    col,
    row,
    // Placement click point (optional): persists as the token's pos so
    // free-placing clients render it exactly where it was placed.
    ...(Number.isFinite(x) && Number.isFinite(z) ? { x, z } : {}),
    idempotencyKey: nextKey('spawnToken', cardId),
  };
}
